export const TITLE = "TITLE";
export const SUBTITLE = "SUBTITLE";
export const PARAGRAPH = "PARAGRAPH";
export const IMAGE = "IMAGE";
export const ZOOMABLEIMAGE = "ZOOMABLEIMAGE";
export const GALLERY = "GALLERY";
export const ORDEREDLIST = "ORDEREDLIST";
export const UNORDEREDLIST = "UNORDEREDLIST";


// WEBPACK FOOTER //
// ./src/components/sectionTypes.js